<template>
  <div class="gf-field gf-field-wysi" :class="{focused}">
    <div class="wysi-editor" ref="mceEditor" :class="{'wysi-inline': mode=='inline', 'wysi-box': mode!='inline'}"></div>
  </div>
</template>

<script>
import { componentMixin } from './FormCommon'

import tinymce from 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/skins/ui/oxide/skin.css';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/code';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/emoticons/js/emojis';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/table';
import 'tinymce/plugins/autoresize';
import 'tinymce/models/dom/model';
import contentUiCss from '!!raw-loader!tinymce/skins/ui/oxide/content.css';
import contentCss from '!!raw-loader!tinymce/skins/content/default/content.css';

var contentCss2=`
html, body {
  font-family: "Inter", -apple-system, blinkmacsystemfont, "San Francisco", "Segoe UI", roboto, "Helvetica Neue", sans-serif;
  font-size: 14px;
  line-height: normal;
}
a {
  text-decoration: underline;
  color: #0284c7;
}

@font-face {
  font-family: "Inter";
  font-weight: 100;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-Thin.eot");
  src: url("/admin/static/fonts/Inter/Inter-Thin.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-Thin.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-Thin.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 200;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-ExtraLight.eot");
  src: url("/admin/static/fonts/Inter/Inter-ExtraLight.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-ExtraLight.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-ExtraLight.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 300;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-Light.eot");
  src: url("/admin/static/fonts/Inter/Inter-Light.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-Light.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 400;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-Regular.eot");
  src: url("/admin/static/fonts/Inter/Inter-Regular.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-Regular.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 500;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-Medium.eot");
  src: url("/admin/static/fonts/Inter/Inter-Medium.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-Medium.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-Medium.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 600;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-SemiBold.eot");
  src: url("/admin/static/fonts/Inter/Inter-SemiBold.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-SemiBold.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-SemiBold.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 700;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-Bold.eot");
  src: url("/admin/static/fonts/Inter/Inter-Bold.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-Bold.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 800;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-ExtraBold.eot");
  src: url("/admin/static/fonts/Inter/Inter-ExtraBold.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-ExtraBold.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-ExtraBold.ttf") format("truetype");
}
@font-face {
  font-family: "Inter";
  font-weight: 900;
  font-style: normal;
  src: url("/admin/static/fonts/Inter/Inter-Black.eot");
  src: url("/admin/static/fonts/Inter/Inter-Black.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/Inter/Inter-Black.woff") format("woff"), url("/admin/static/fonts/Inter/Inter-Black.ttf") format("truetype");
}
@font-face {
  font-family: "PT Sans";
  font-weight: 400;
  font-style: normal;
  src: url("/admin/static/fonts/PTSans/PTSans-Regular.eot");
  src: url("/admin/static/fonts/PTSans/PTSans-Regular.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/PTSans/PTSans-Regular.woff") format("woff"), url("/admin/static/fonts/PTSans/PTSans-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "PT Sans";
  font-weight: 400;
  font-style: italic;
  src: url("/admin/static/fonts/PTSans/PTSans-Italic.eot");
  src: url("/admin/static/fonts/PTSans/PTSans-Italic.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/PTSans/PTSans-Italic.woff") format("woff"), url("/admin/static/fonts/PTSans/PTSans-Italic.ttf") format("truetype");
}
@font-face {
  font-family: "PT Sans";
  font-weight: 700;
  font-style: normal;
  src: url("/admin/static/fonts/PTSans/PTSans-Bold.eot");
  src: url("/admin/static/fonts/PTSans/PTSans-Bold.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/PTSans/PTSans-Bold.woff") format("woff"), url("/admin/static/fonts/PTSans/PTSans-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "PT Sans";
  font-weight: 700;
  font-style: italic;
  src: url("/admin/static/fonts/PTSans/PTSans-BoldItalic.eot");
  src: url("/admin/static/fonts/PTSans/PTSans-BoldItalic.eot?#iefix") format("embedded-opentype"), url("/admin/static/fonts/PTSans/PTSans-BoldItalic.woff") format("woff"), url("/admin/static/fonts/PTSans/PTSans-BoldItalic.ttf") format("truetype");
}

`;

export default {
  props: ["placeholder", "mode"],
  mixins: [componentMixin],
  data: ()=>({
    focused: false,
    newContent: "",
  }),
  methods: {
    initEditor(editor) {
      this.mceEditor=editor;
      editor.setContent(this.componentValue || "");
      editor.on('change', (e)=>{
        var content=editor.getContent();
        this.newContent=content;
        this.componentValue=content;
      });
      if (this.disabled)
        editor.mode.set("readonly");
      else
        editor.mode.set("design");
    },
    setupEditor(editor) {
      editor.on('keydown', (e)=>{
      });
      editor.on('paste', (e)=>{
      });
      editor.on('focus', (e)=>{
        this.focused=true;
        window.focusedMceEditor=editor;
        // workaround for buggy toolbar placement (part 2)
        if (this.mode=='inline') {
          this.$nextTick(()=>{
            try {
              for(var i=0;i<2;i++)
                for(var eh of editor._eventDispatcher.bindings.resizewindow || [])
                  try { eh.func({}) } catch(e) { }
              editor.show();
            } catch(e) {console.log(e)}
          });
        }
      });
      editor.on('blur', (e)=>{
        this.focused=false;
      });
    },
  },
  watch: {
    componentValue() {
      console.log(this.componentValue, this.newContent);
      if (this.componentValue!=this.newContent) {
        this.newContent=this.componentValue;
        this.mceEditor.setContent(this.componentValue || "");
      }
    },
  },
  mounted() {
    var config={
      target: this.$refs.mceEditor,
      plugins: ['lists', 'link', 'table', 'autoresize'],
      table_toolbar: "",
      link_title: false,
      menubar: false,
      contextmenu: false,
      statusbar: false,
//       height: 400,
      valid_styles: {
        "*": "color, text-decoration, text-align"
      },
      toolbar: "bold italic underline strikethrough forecolor | alignleft aligncenter alignright alignjustify | link unlink | numlist bullist outdent indent",
      formats: {
        serif: {block: "p", classes: "serif", exact: true},
      },
      style_formats: [
        {title: "Serif", format: "serif"},
      ],
      init_instance_callback: this.initEditor.bind(this),
      setup: this.setupEditor.bind(this),
      skin: false,
      content_css: false,
    };
    if (this.mode=="inline") {
      config.inline=true;
    } else {
      config.content_style=`${contentUiCss}\n${contentCss}\n${contentCss2}`;
    }
    /*this.$nextTick(()=>*/tinymce.init(config)/*)*/;
  },
}
export { contentCss2 };

</script>
